import { inventory } from '@api';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';
import { z } from 'zod';

export type ConversationInventory = z.infer<
  typeof inventory.conversationInventory.schema
>;

export type FormattedConversationInventory = ConversationInventory & {
  insightTitles?: Record<string, string>;
  economicCalendarEntityNames?: Record<string, string>;
};

export const EMPTY_CONVERSATION_INVENTORY: ConversationInventory =
  Object.freeze({}) as ConversationInventory;

export const getConversationInventory = async (
  conversationId: string
): Promise<ConversationInventory> => {
  const result = await apiFetch<ConversationInventory>(
    inventory.conversationInventory.path(conversationId),
    { schema: inventory.conversationInventory.schema }
  );

  if (result.error || result.validationError) {
    return EMPTY_CONVERSATION_INVENTORY;
  }

  return result.data ?? EMPTY_CONVERSATION_INVENTORY;
};
